import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

type IProps = {
  text: string;
  minHeight?: any;
  height?: string;
};

const EmptyMessage: React.FC<IProps> = ({
  text,
  minHeight = "300px",
  height = "100%",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height,
        minHeight,
        width: "100%",
      }}
    >
      <ErrorOutlineIcon color="primary" sx={{ fontSize: 60, mb: 1 }} />
      <Typography variant="h5" component="h6">
        {text}
      </Typography>
    </Box>
  );
};

export default EmptyMessage;
